import React, { FC, useEffect } from 'react';
import clsx from 'clsx';

import CommonQuestions from 'components/CommonQuestions';
import Header from 'components/Header';
import Footer from 'components/Footer';

import ConfettiMobil from 'images/сonfetti-mobil.svg';
import ConfettiDesktop from 'images/сonfetti-desktop.svg';
import useLayoutTheme from 'hooks/useLayoutTheme';
import { LocalStorageKeyName } from 'enums/LocalStorageKeyName';
import { Themes } from 'styles/themes/ThemeTypes';

import styles from './MainLayout.module.scss';

interface MainLayoutProps {
  confettiBackground?: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({ children, confettiBackground }) => {
  const { themeStyles, setTheme } = useLayoutTheme();

  useEffect(() => {
    const theme = (localStorage.getItem(LocalStorageKeyName.Theme) ?? Themes.DEFAULT) as Themes;
    setTheme(theme);
  }, []);

  return (
    <div className={clsx(styles.layoutContainer, themeStyles.layoutContainer)}>
      <Header />
      <div className={clsx(styles.layoutContent, themeStyles.layoutContent)}>
        {confettiBackground && (
          <picture>
            <source media="(max-width: 1023px)" srcSet={ConfettiMobil} />
            <source media="(min-width: 1024px)" srcSet={ConfettiDesktop} />
            <img src={ConfettiDesktop} alt="Background" className={styles.confetti} />
          </picture>
        )}
        {children}
        <CommonQuestions />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
